import * as React from 'react'
import { dispatchToProps } from './VoiceList.container'
import { IVoice } from 'features/Voices/types'
import { Table, TableHeader, TableRow } from 'features/Table'
import Pagination from 'components/Pagination'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import Button from 'components/Button'
import { Row, Col } from 'components/Layout'
import cn from 'classnames'
import * as sLay from 'styles/modules/layout.scss'
import * as sMarg from 'styles/modules/margins.scss'
import * as sText from 'components/Text/Text.scss'

export interface IVoicesListComponentProps {
  cacheKey: string
  page: number
  totalPages: number
  loading: boolean
  results: IVoice[]
  getVoices: typeof dispatchToProps['getVoices']
  replace: typeof dispatchToProps['replace']
  showVoiceCreateModal: typeof dispatchToProps['showVoiceCreateModal']
}

export class VoicesListComponent extends React.Component<IVoicesListComponentProps> {
  componentWillMount() {
    const { getVoices, cacheKey, page } = this.props
    getVoices({ cacheKey, page })
  }
  componentWillReceiveProps(nextProps: IVoicesListComponentProps) {
    const { getVoices, page, cacheKey } = nextProps
    if (cacheKey && cacheKey !== this.props.cacheKey) {
      getVoices({ cacheKey, page })
    }
  }
  render() {
    const { results, loading, totalPages, page, replace, showVoiceCreateModal } = this.props
    return (
      <div>
        <div
          className={cn(
            sMarg.mb30,
            sLay['layout-gt-xs-column'],
            sLay['layout-gt-xs-row'],
            sLay['layout-align-start-center']
          )}
        >
          <div className={cn(sLay.flex, sText.descrip3, sMarg.mb15xs)}>
            {/* Add voices automatically. <a target='_blank' rel='noopener noreferrer' href='https://help.thinkpickle.com.au/voices/adding-voices'>Learn how.</a> */}
          </div>
          <Row className={cn(sLay['layout-gt-xs-column'], sLay['layout-gt-xs-row'], 'sm')}>
            <Col className={cn('sm')}>
              <Button
                color="tertiary"
                size="sm"
                onClick={() => showVoiceCreateModal({})}
                rect
                style={{ width: '100%' }}
              >
                Create Actor Recording
              </Button>
            </Col>
          </Row>
        </div>
        {results.length === 0 ? (
          <EmptyMessageCard
            loading={loading}
            title="You have no voice actor recordings yet."
            subtitle="Select from our curated list of voice actors."
          />
        ) : (
          <div>
            <Table
              header={
                <TableHeader>
                  <div>Title</div>
                  <div style={{ maxWidth: '80px' }} className={sLay['hide-xs']}>
                    Reads
                  </div>
                  <div style={{ maxWidth: '150px' }} className={sLay['hide-xs']}>
                    Voice Actor ID
                  </div>
                  <div style={{ maxWidth: '80px' }} className={sLay['hide-xs']}>
                    Price
                  </div>
                  <div style={{ maxWidth: '76px' }} />
                </TableHeader>
              }
            >
              {results.map(voice => {
                return (
                  <TableRow key={voice.id}>
                    <div>{voice.title}</div>
                    <div style={{ maxWidth: '80px' }} className={sLay['hide-xs']}>
                      {voice.reads.length}
                    </div>
                    <div style={{ maxWidth: '150px' }} className={sLay['hide-xs']}>
                      {voice.talendID}
                    </div>
                    <div style={{ maxWidth: '80px' }} className={sLay['hide-xs']}>
                      ${voice.price}
                    </div>
                    <div style={{ maxWidth: '76px' }}>
                      <Button
                        color="tertiary"
                        size="xs"
                        ghost
                        to={`/dashboard/voice-actor-recordings/${voice.id}`}
                      >
                        View
                      </Button>
                    </div>
                  </TableRow>
                )
              })}
            </Table>
          </div>
        )}
        <Pagination
          page={page}
          numPages={totalPages}
          onClick={nextPage =>
            replace({
              pathname: location.pathname,
              query: {
                page: nextPage,
              },
            })
          }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceList/VoiceList.tsx